import styled from 'styled-components';

export const ButtonOpenFB = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  justify-content: center;
  
  span {
    color: #666;
    font-size: 0.9rem;
  }
`;
